// extracted by mini-css-extract-plugin
export var layout = "LifeInsuranceCalculator-module--layout--41-SY";
export var main = "LifeInsuranceCalculator-module--main--kpeY0";
export var results = "LifeInsuranceCalculator-module--results--QqSsW";
export var root = "LifeInsuranceCalculator-module--root--FlEZ3";